import { useEffect, useState } from "react";
import { getAuthToken } from "../auth";
import { EMPTY_FILTERS, fetchDashboardSummary, type DashboardFilters, type DashboardScope, type DashboardSummary } from "../api/dashboardApi";

/** Compteurs du tableau de bord, rechargés à chaque changement de filtre. */
export function useDashboardSummary(scope: DashboardScope) {
  const [filters, setFilters] = useState<DashboardFilters>(EMPTY_FILTERS);
  const [summary, setSummary] = useState<DashboardSummary | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!getAuthToken()) return;
    let cancelled = false;
    fetchDashboardSummary(scope, filters)
      .then((result) => {
        if (!cancelled) {
          setSummary(result);
          setError(null);
        }
      })
      .catch((err) => {
        if (!cancelled) setError(err instanceof Error ? err.message : "Chargement des compteurs impossible.");
      });
    return () => {
      cancelled = true;
    };
  }, [scope, filters]);

  return { filters, setFilters, summary, error };
}
